import { ActionTypes } from '../../actions/ActionTypes';
import { IBaseStateModel } from '../../models/StateModels';
import { IAction, IApiAction, IInputAction, IPromiseAction } from '../../models/ActionModels';
import ReducerFunctions from './ReducerFunctions';

export default <TInput, TState extends IBaseStateModel, TOutput>(
  actionSubType: string,
  defaults: TState
) => (
  state: TState = defaults,
  action: IApiAction<TOutput> | IPromiseAction<TInput> | IInputAction<TInput> | IAction<TInput>
): TState => {
  switch (action.type) {
    case ActionTypes.PAGE_LOADED:
      if (action.subtype === actionSubType)
        return ReducerFunctions.api_page_loaded_state<any, typeof state, IAction<any>>(
          state,
          action
        );
      break;
    case ActionTypes.PAGE_UNLOADED:
      if (action.subtype === actionSubType)
        return ReducerFunctions.api_page_unloaded_state<any, typeof state, IAction<any>>(
          state,
          action
        );
      break;
    case ActionTypes.ASYNC_SET:
      if (action.subtype === actionSubType && 'isInterfaceInputAction' in action)
        return ReducerFunctions.api_set_input_state<any, typeof state, IInputAction<any>>(
          state,
          action
        );
      break;
    case ActionTypes.ASYNC_START:
      if (action.subtype === actionSubType && 'isInterfacePromiseAction' in action)
        return ReducerFunctions.api_async_start_state(state, action);
      break;
    case ActionTypes.ASYNC_COMPLETE:
      if (action.subtype === actionSubType && 'isInterfaceApiAction' in action)
        return ReducerFunctions.api_async_complete_state<
          TOutput,
          typeof state,
          IApiAction<TOutput>
        >(state, action);
      break;
    case ActionTypes.RESET_STORE:
      if (action.subtype === actionSubType && 'isInterfaceInputAction' in action)
        return ReducerFunctions.api_reset_store<typeof state, IInputAction<any>>(state, action);
      break;
    default:
      return state;
  }

  return state;
};
